import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createStaticVNode("<p class=\"u-mgRight--10 p-generateAi__text\"><span>AI</span> 処理中</p><div class=\"ellipsis-container\"><div class=\"ellipsis-dot\"></div><div class=\"ellipsis-dot\"></div><div class=\"ellipsis-dot\"></div></div>", 2);
export default /*#__PURE__*/ _defineComponent({
    __name: 'AiProcessingIndicator',
    props: {
        cancelable: { type: Boolean }
    },
    emits: ['cancel'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _hoisted_1,
                (_ctx.cancelable)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "c-btn--off u-mgLeft--10",
                        onClick: _cache[0] || (_cache[0] = ($event) => (emit('cancel')))
                    }, "キャンセル"))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
